import React, { memo } from 'react';

import { FAQContainer } from 'containers';

export const FAQPage = memo(() => (
  <div>
    <FAQContainer />
  </div>
));
